export const RELATIONSHIP_TYPES = {
    DIRECT_REPORT: "direct_report",
    MANAGER: "manager",
    PEER: "peer",
    SKIP_LEVEL: "skip_level",
    OTHER: "other",
};

export const DOCUMENT_UPLOAD_TYPES = {
    EXISTING_DOCUMENT: "existing_document",
    PAST_REVIEW: "past_review",
    GOALS: "goals",
    OTHER: "other",
};

export const REVIEW_TYPES = {
    SELF: "self",
    CONNECTIONS: "connections",
};

export const PERFORMANCE_REVIEW_EVENT_PREFIX = "performance_review_";
